import { Link } from "react-router-dom";
import { ArrowUpRight, Phone, Mail, MapPin } from "lucide-react";

export const Footer = () => {
  return (
    <footer className="bg-card border-t border-border">
      <div className="container-wide py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8">
          {/* Brand */}
          <div className="space-y-6">
            <Link to="/" className="flex items-center gap-3">
              <div className="flex gap-0.5">
                <div className="w-2 h-8 gradient-blue" />
                <div className="w-2 h-8 gradient-orange" />
                <div className="w-2 h-8 gradient-green" />
              </div>
              <span className="font-heading font-bold text-lg text-foreground">
                FREITAG<span className="text-muted-foreground font-normal">-GRUPPE</span>
              </span>
            </Link>
            <p className="text-sm text-muted-foreground font-body leading-relaxed">
              Drei Kompetenzen unter einem Dach. Ihr starker Partner für Bau, Garten- und Landschaftsbau sowie Sachverständigenleistungen.
            </p>
          </div>

          {/* Unternehmen */}
          <div className="space-y-4">
            <h4 className="font-heading font-semibold text-sm uppercase tracking-wider text-foreground">Unternehmen</h4>
            <div className="space-y-3">
              <Link to="/bauunternehmung" className="flex items-center gap-2 text-sm text-brand-blue-light font-body hover:opacity-80">
                <span className="w-1.5 h-1.5 bg-brand-blue" />
                Bauunternehmung
              </Link>
              <Link to="/galabau" className="flex items-center gap-2 text-sm text-brand-green-light font-body hover:opacity-80">
                <span className="w-1.5 h-1.5 bg-brand-green" />
                Galabau
              </Link>
              <Link to="/sachverstaendiger" className="flex items-center gap-2 text-sm text-brand-orange-light font-body hover:opacity-80">
                <span className="w-1.5 h-1.5 bg-brand-orange" />
                Sachverständiger
              </Link>
            </div>
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <h4 className="font-heading font-semibold text-sm uppercase tracking-wider text-foreground">Quicklinks</h4>
            <div className="space-y-3">
              {[
                { label: "Über Uns", to: "/#ueber-uns" },
                { label: "Leistungen", to: "/#leistungen" },
                { label: "Impressum", to: "/impressum" },
                { label: "Datenschutz", to: "/datenschutz" },
                { label: "AGB", to: "/agb" },
              ].map((item) => (
                <Link
                  key={item.label}
                  to={item.to}
                  className="flex items-center gap-1 text-sm text-muted-foreground font-body hover:text-foreground group"
                >
                  {item.label}
                  <ArrowUpRight className="w-3 h-3 opacity-0 group-hover:opacity-100" />
                </Link>
              ))}
            </div>
          </div>

          {/* Contact */}
          <div className="space-y-4">
            <h4 className="font-heading font-semibold text-sm uppercase tracking-wider text-foreground">Kontakt</h4>
            <div className="space-y-3">
              <div className="flex items-start gap-3 text-sm text-muted-foreground font-body">
                <MapPin className="w-4 h-4 mt-0.5 shrink-0" />
                <span>Hinter dem Turme 29<br />38114 Braunschweig</span>
              </div>
              <div className="flex items-center gap-3 text-sm text-muted-foreground font-body">
                <Phone className="w-4 h-4 shrink-0" />
                <span>+49 (0) 531 87 46 10</span>
              </div>
              <div className="flex items-center gap-3 text-sm text-muted-foreground font-body">
                <Mail className="w-4 h-4 shrink-0" />
                <span>info@freitag-bs.de</span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-16 pt-8 border-t border-border flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-xs text-muted-foreground font-body">
            © {new Date().getFullYear()} Freitag-Gruppe. Alle Rechte vorbehalten.
          </p>
          <div className="flex gap-0.5">
            <div className="w-12 h-1 gradient-blue" />
            <div className="w-12 h-1 gradient-orange" />
            <div className="w-12 h-1 gradient-green" />
          </div>
        </div>
      </div>
    </footer>
  );
};
